<template>
    <BreadCrumb PageTitle="Liste des poids" />
    <ListePoids/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../../components/Common/BreadCrumb.vue";
    import ListePoids from "../../../components/Ecommerce/Poids/ListePoids.vue";

    export default defineComponent({
      name: "ListePoidsPage",
      components: {
        BreadCrumb,
        ListePoids,
      },
    });
  </script>